module.exports = __webpack_public_path__ + "img/thank_2021_tip1_mall.38527c59.png";